import Box from '@mui/material/Box';
export default Box;
export * from '@mui/material/Box';
